import { FC, useMemo } from 'react';
import { Navigate, useLocation, useRouteError } from 'react-router-dom';

import { buildUrl } from 'utilities/strings';

const RedirectToError: FC = () => {
  const from = useLocation();
  const url = useMemo(() => buildUrl('Root.children.Error'), []);
  const error = useRouteError();

  return (
    <Navigate
      replace
      state={{ error, from }}
      to={url}
    />
  );
};

export default RedirectToError;
